// This is the runtime configuration file.  It complements the Gruntfile.js by
// supplementing shared properties.
require.config({
  paths: {
    "vendor": "../vendor",
    "almond": "../vendor/bower/almond/almond",
    "underscore": "../vendor/bower/lodash/dist/lodash.underscore",
    "jquery": "../vendor/bower/jquery/jquery",
    "backbone": "../vendor/bower/backbone/backbone",
    "swiper": "../vendor/bower/swiper/dist/idangerous.swiper",
    "syze": "../vendor/bower/syze/syze",
    "skrollr": "../vendor/bower/skroll/skrollr",
    "skrollrCss": "../vendor/bower/skroll/skrollr.stylesheets",
    "mediaelement": "../vendor/bower/mediaelements/mediaelement-and-player",
    "jqueryBrowser": "../vendor/bower/jquery.browser/dist/jquery.browser",
    //"animate": "../vendor/bower/adobe/edge.2.0.0.min",
    //"animate_loader": "../vendor/bower/adobe/loader",
    "videojs": "../vendor/bower/videojs/video",
    //"dotdotdot": "../vendor/bower/jquery-dotdot/jquery.dotdotdot",
    "htmlparser": "../vendor/bower/htmlparser/htmlparser"
  },
  shim: {
        /*"animate": {
            deps: ['jquery'],
            exports: 'AdobeEdge'
        },
          "animate_loader": {
            deps: ['jquery','animate']
        },
        "dotdotdot": {
            deps: ['jquery']
        }*/
       
  }
});
/*
define(["jquery"], function($) {
	console.log('ADD',window.jQuery)
     return window.jQuery ;
});
*/;
define("config", function(){});

